import React, { useEffect, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { HttpMethods, FetchContext, ApiRoutes, ToastContext } from '../../../contexts';

import {
    Paper,
    Avatar,
    Table,
    TableHead,
    TableBody,  
    TableRow,
    TableCell,      
    Typography,
    Button,
    LinearProgress,
    TextField
} from '@material-ui/core';
import DeleteForever from '@material-ui/icons/DeleteForever';

import { OwnerAssignmentProvider, OwnerAssignmentContext } from './OwnerAssignmentContext';
import { NavContext, NavRoutes } from '../../../contexts';
import { SearchUser } from '../../../common';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    ownerTitle: {
        marginBottom: '20px',
        fontSize: '1rem',
        fontWeight: 500
    },
    changeOwnerContainer: {
        display: 'flex'
    },
    changeOwnerName: {
        alignSelf: 'center',
        fontSize: '1rem',
        marginRight: '30px'
    },
    changeOwnerButtonContainer: {
        alignSelf: 'center'
    },
    changeOwnerButton: {
        fontSize: '12px'
    },
    searchOwnerContainer: {
        display: 'flex'
    },
    searchOwner: {
        width: '350px',
        marginRight: '35px'
    },
    cancelOwnerButton: {
        fontSize: '12px',
        alignSelf: 'center'
    },
    codeContainer: {
        marginTop: '40px',
        display: 'flex'
    },
    codeTitle: {
        display: 'flex',
        alignSelf: 'center',
        fontSize: '1rem',
        marginRight: '20px'
    },
    pmTitle: {
        margin: "40px 0px 20px",
        fontSize: '1rem',
        fontWeight: 500
    },
    searchPM: {
        width: '350px'
    },
    root: {
        marginTop: '40px',
        width: '350px',
        overflow: 'hidden',
    },
    pmsTitle: {
        fontSize: '1rem'
    },
    deletePM: {
        cursor: 'pointer',
        alignSelf: 'center'
    },
    saveButton: {
        marginTop: '40px'
    },
    secondaryButtons: {
        marginTop: '40px',
        marginLeft: '20px'
    },
    icon: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    table: {

    }
}));

const PageContent = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);
    const classes = useStyles();

    useEffect(() => {
        addBreadcrumbToken("Project managers assignment");
    }, [])

    const {
        showSuccessMessage,
        showWarningMessage,
        showErrorMessage
      } = useContext(ToastContext);

    const {
        navigateTo
    } = useContext(NavContext)

    const {
        state,
        getRolesAsync,
        getTeamAsync,
        saveProjectTeamAsync,
        deleteTeamAsync
    } = useContext(OwnerAssignmentContext);
    
    const {
        roles,
        currentTeam,
        editedAssignment,
        isSaved,
        isLoadingTeam
    } = state;

    useEffect(() => {
        getRolesAsync();
    }, [])

    const [ownersId, setOwnersId] = useState(null);
    const [itOwnerCode, setItOwnerCode] = useState("");
    const [pmsId, setPmsId] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [isAddingInRole, setIsAddingInRole] = useState(false);
    const [isUpdatingInRole, setIsUpdatingInRole] = useState(false);
    const [ownerObject, setOwnerObject] = useState(null);
    const [pmsObject, setPmsObject] = useState([]);
    const [pmChanged, setPmChanged] = useState(null);
    const [editOwner, setEditOwner] = useState(true);

    useEffect(() => {
        if (roles !== null){
            let owners = null;
            let pms = null;
            roles.map(role => {
                if (role.groupName == "Owners")
                    owners = role.groupAADReference;
                else if (role.groupName == "Project Managers")
                    pms = role.groupAADReference;
            });

            setOwnersId(owners);
            setPmsId(pms);
        }
    }, [roles])

    useEffect(() => {
        if (isSaved)
            navigateTo(NavRoutes.Admin.AssignmentList, []);
    }, [isSaved])

    const { teamId } = useParams();
    useEffect(() => {
        if (teamId !== "0"){
            getTeamAsync(teamId);
            setEditOwner(false);
        }
    }, [teamId])

    useEffect(() => {
        if (currentTeam !== null){
            setOwnerObject({ name: currentTeam.owner.displayName, key: currentTeam.owner.userKey });

            if (currentTeam.code)
                setItOwnerCode(currentTeam.code);

            if (currentTeam && currentTeam.projectManagers && currentTeam.projectManagers.length > 0){
                const currentPMs = [];
                currentTeam.projectManagers.map(pm => {
                    const pmsObject = { name: pm.displayName, key: pm.userKey };
                    currentPMs.push(pmsObject);
                });
                setPmsObject(currentPMs);
            }
        }
    }, [currentTeam])

    const loadOwners = (inputValue, callback) => {
        return fetchAuthorized(ApiRoutes.Graph.GetMembers({ groupId: ownersId, userFullPartialName: inputValue }),
        {
            method: HttpMethods.GET
        })
        .then(r => r.json())
        .then(users => callback(users))
        .catch(error => {
            console.error(error);
            callback([]);
        });
    }

    const loadPMs = (inputValue, callback) => {
        return fetchAuthorized(ApiRoutes.Graph.GetMembers({ groupId: pmsId, userFullPartialName: inputValue }),
        {
            method: HttpMethods.GET
        })
        .then(r => r.json())
        .then(users => callback(users))
        .catch(error => {
            console.error(error);
            callback([]);
        });
    }

    useEffect(() => {
        setDisabled(isAddingInRole || isUpdatingInRole);
    }, [isAddingInRole, isUpdatingInRole])

    const ownerChangeHandler = (user) => {
        const checkOwnerName = user ? user.displayName : null;
        const checkOwnerKey = user ? user.id : null;
        setOwnerObject({ name: checkOwnerName, key: checkOwnerKey });

        if (checkOwnerKey)
            setEditOwner(false);

        //this thing below needs to "awake" the component to re-render states since state array doesn't do that 
        if (pmChanged === null)
            setPmChanged(true);
        else
            setPmChanged(!pmChanged);
    }

    const pmChangeHandler = (user) => {
        const newPMName = pmsObject;
        const checkPmName = user ? user.displayName : null;
        const checkPmKey = user ? user.id : null;
        if (checkPmName && checkPmKey){
            newPMName.push({ name: checkPmName, key: checkPmKey });
            setPmsObject(newPMName);
        }

        //this thing below needs to "awake" the component to re-render states since state array doesn't do that 
        if (pmChanged === null)
            setPmChanged(true);
        else
            setPmChanged(!pmChanged);
    }

    function removePM(unsolicitedPMKey){
        const updatedPms = pmsObject;
        let position = null;
        updatedPms.map((projectManager, index) => {
            if (projectManager.key == unsolicitedPMKey)
                position = index;
        });

        updatedPms.splice(position, 1);
        setPmsObject(updatedPms);

        //this thing below needs to "awake" the component to re-render states since state array doesn't do that 
        if (pmChanged === null)
            setPmChanged(true);
        else
            setPmChanged(!pmChanged);
    }

    return (
        <div>
            {
                isLoadingTeam ?
                <LinearProgress color="primary" /> :
                <>
                    <div className={classes.ownerTitle}>
                        Owner
                    </div>

                    {
                        !editOwner
                        ?
                        <div className={classes.changeOwnerContainer}>
                            <div className={classes.changeOwnerName}>
                                {ownerObject && ownerObject.name}
                            </div>
                            <div className={classes.changeOwnerButtonContainer}>
                                <Button
                                    className={classes.changeOwnerButton}
                                    color="primary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => setEditOwner(true)}
                                >Change Owner</Button>
                            </div>
                        </div>
                        :
                        <div className={classes.searchOwnerContainer}>
                            <div className={classes.searchOwner}>
                                <SearchUser
                                    getOptionLabel={option => option.displayName}
                                    getOptionValue={option => option.id}                    
                                    loadOptions={loadOwners}
                                    disabled={disabled}
                                    onChange={ownerChangeHandler}
                                />
                            </div>
                            {
                                ownerObject &&
                                <Button
                                    className={classes.cancelOwnerButton}
                                    color="primary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => setEditOwner(false)}
                                >Cancel</Button>
                            }
                        </div>
                    }

                    <div className={classes.codeContainer}>
                        <div className={classes.codeTitle}>
                            Code
                        </div>
                        <TextField
                            inputProps={{ style: { padding: '15px', backgroundColor: '#fff' } }}
                            value={itOwnerCode}
                            variant="outlined"
                            onChange={event => {
                                event.persist();
                                setItOwnerCode(event.target.value);
                            }}
                        />
                    </div>
                        
                    <div className={classes.pmTitle}>
                        Project manager
                    </div>
                    <div className={classes.searchPM}>
                        <SearchUser
                            getOptionLabel={option => option.displayName}
                            getOptionValue={option => option.id}                    
                            loadOptions={loadPMs}
                            disabled={disabled}
                            onChange={pmChangeHandler}
                        />
                    </div>

                    {
                        pmsObject &&
                        pmsObject.length > 0 &&
                        <Paper className={classes.root}>
                        <Table className={classes.table} arial-label="role table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.pmsTitle}>
                                        Selected project managers
                                    </TableCell>
                                    <TableCell align="right"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pmsObject.map((pmAdded, index) => 
                                    <TableRow hover key={index}>
                                        <TableCell component="th" scope="row">
                                            {pmAdded.name}
                                        </TableCell>
                                        <TableCell align="right">
                                            <div className={classes.deletePM} onClick={() => removePM(pmAdded.key)}>
                                                <DeleteForever />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                    }

                    <Button
                        className={classes.saveButton}
                        color="primary"
                        size="small"
                        variant="contained"
                        onClick={() => {
                            if (ownerObject.key !== null && itOwnerCode && pmsObject.length > 0){
                                const pmsKey = [];
                                pmsObject.map(pm => pmsKey.push(pm.key));

                                const newAssignment = {
                                    projectTeamId: currentTeam ? currentTeam.projectTeamId : 0,
                                    ownerKey: ownerObject.key,
                                    code: itOwnerCode,
                                    projectManagerKeys: pmsKey
                                };

                                saveProjectTeamAsync(newAssignment);
                            }

                            else
                                showErrorMessage("Owner, code and project manager must be entered");
                        }}
                    >Save</Button>

                    {
                        teamId !== "0" &&
                        <Button
                            className={classes.secondaryButtons}
                            color="secondary"
                            size="small"
                            variant="contained"
                            onClick={() => {
                                if (window.confirm("Are you sure you want to delete these assignments?"))
                                    sendDataAsync();

                                async function sendDataAsync(){
                                    await deleteTeamAsync(teamId);
                                    navigateTo(NavRoutes.Admin.AssignmentList, []);
                                }
                            }}
                        >Delete assignments</Button>
                    }

                    <Button
                        className={classes.secondaryButtons}
                        size="small"
                        variant="contained"
                        onClick={() => navigateTo(NavRoutes.Admin.AssignmentList, [])}
                    >Cancel</Button>
                </>
            }
        </div>
    );
}

export const OwnerAssignmentPage = () => {
    return (
        <OwnerAssignmentProvider>
            <PageContent />
        </OwnerAssignmentProvider>
    );
}